import { Link } from "react-router-dom"
import { toSalusionPrivate } from "../../util"
import referral from "../../assets/referral.svg"

export default function Hero() {
	return (
		<section className="first-section first-padding" id="hero">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-md-6">
						<div className="hero-content">
							<h1>Support Better Benefits</h1>
							<h2 style={{ color: "#7fc2ff" }}>Partner with Salusion</h2>

							<p>
								Salusion's Broker program allows you to keep your relationship with your customer.  Sign up take include our ICHRA in your customer offering.
							</p>

							<Link
								className="btn-linear"
								onClick={(event) => toSalusionPrivate(event, "/create-referral-account", false)}
							>
								Create A Broker Account
							</Link>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<img src={referral} alt="salusion logo" />
					</div>
				</div>
			</div>
		</section>
	)
}
